export default __webpack_public_path__ + "static/media/St basil.c2464f52.svg";